import { Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { Box } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

export const ReferralCodeModal = ({
  isOpen,
  setIsOpen,
  updateReferralCode,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  updateReferralCode: (referralCode: boolean) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      title={t('ui.event-management.generic.dialog.are-you-sure')}
      open={isOpen}
      onClose={() => {
        updateReferralCode(false);
        setIsOpen(false);
      }}
      onSubmit={() => {
        updateReferralCode(true);
        setIsOpen(false);
      }}
      content={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: spacingSizeMap.S,
          }}
        >
          <TextV2 color="textSecondary">
            <Trans
              i18nKey="ui.event-management.referral-code.dialog.content1"
              t={t}
              components={{
                styledtext: (
                  <TextV2
                    variant="bodyBold"
                    component="span"
                    color="textSecondary"
                  />
                ),
              }}
            />
          </TextV2>
          <TextV2 color="textSecondary">
            <Trans
              i18nKey="ui.event-management.referral-code.dialog.content2"
              t={t}
              count={2}
              components={{
                styledtext: (
                  <TextV2
                    variant="bodyBold"
                    component="span"
                    color="textSecondary"
                  />
                ),
              }}
            />
          </TextV2>
        </Box>
      }
      primaryButtonText={t(
        'ui.event-management.referral-code.dialog.confirm-button',
      )}
      secondaryButtonText={t('ui.event-management.dialog.no-never-mind')}
    />
  );
};
